import UserIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DeviceUnknownIcon from "@mui/icons-material/DeviceUnknown";
import OrganizationIcon from "@mui/icons-material/Home";
import CancelIcon from "@mui/icons-material/Cancel";
import {usePermission} from "../hooks/usePermission";
import {PermissionLevel} from "../app/api/model/user";
import {RoutePath} from "../types";
import {useTranslation} from "react-i18next";
import {List} from "@mui/material";
import {LocalShipping} from "@mui/icons-material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import SelectableListItem from "./SelectableListItem";

export const NavigationBar = () => {
    const {hasPermission} = usePermission();
    const {t} = useTranslation();

    return (
        <List data-test="actionLinks">
            {hasPermission(PermissionLevel.ADMIN) && (
                <SelectableListItem
                    dataTest="usersLink"
                    to={`/${RoutePath.USERS}`}
                    matchPath={`/${RoutePath.USERS}/*`}
                    icon={<UserIcon />}
                    text={t("generic_users")}
                />
            )}
            {
                <SelectableListItem
                    dataTest="organizationsLink"
                    to={`/${RoutePath.ORGANIZATIONS}`}
                    matchPath={`/${RoutePath.ORGANIZATIONS}/*`}
                    icon={<OrganizationIcon />}
                    text={t("generic_organizations")}
                />
            }
            {hasPermission(PermissionLevel.MANAGER) && (
                <SelectableListItem
                    to={`/${RoutePath.COMPANYCARDS}`}
                    matchPath={`/${RoutePath.COMPANYCARDS}/*`}
                    icon={<CardGiftcardIcon />}
                    text={t("generic_companyCards")}
                    dataTest="companyCardsLink"
                />
            )}
            {
                <SelectableListItem
                    to={`/${RoutePath.ASSETS}`}
                    matchPath={`/${RoutePath.ASSETS}/*`}
                    icon={<OrganizationIcon />}
                    text={t("generic_assets")}
                    dataTest="assetsLink"
                />
            }
            {
                <SelectableListItem
                    to={`/${RoutePath.DEVICES}`}
                    matchPath={`/${RoutePath.DEVICES}/*`}
                    icon={<SatelliteAltIcon />}
                    text={t("generic_devices")}
                    dataTest="devicesLink"
                />
            }
            {
                <SelectableListItem
                    to={`/${RoutePath.ORDERS}?sort=-createdAt`}
                    matchPath={`/${RoutePath.ORDERS}/*`}
                    icon={<ShoppingCartIcon />}
                    text={t("generic_orders")}
                    dataTest="ordersLink"
                />
            }
            {
                <SelectableListItem
                    to={`/${RoutePath.TERMINATIONS}`}
                    matchPath={`/${RoutePath.TERMINATIONS}/*`}
                    icon={<CancelIcon />}
                    text={t("generic_terminations")}
                    isDisabled
                    dataTest="terminationsLink"
                />
            }
            {
                <SelectableListItem
                    to={`/${RoutePath.SHIPMENTS}?sort=-createdAt`}
                    matchPath={`/${RoutePath.SHIPMENTS}/*`}
                    icon={<LocalShipping />}
                    text={t("generic_shipments")}
                    dataTest="shipmentsLink"
                />
            }
            {
                <SelectableListItem
                    to={`/${RoutePath.FIRMWARES}`}
                    matchPath={`/${RoutePath.FIRMWARES}/*`}
                    icon={<DeviceUnknownIcon />}
                    text={t("generic_firmwares")}
                    dataTest="firmwaresLink"
                />
            }
            {
                <SelectableListItem
                    to={`/${RoutePath.SETTINGS}`}
                    matchPath={`/${RoutePath.SETTINGS}/*`}
                    icon={<SettingsIcon />}
                    text={t("generic_settings")}
                    dataTest="settingsLink"
                />
            }
        </List>
    );
};
